import { motion } from 'framer-motion'
import styled from 'styled-components'

const StModalWrapper = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  /* One above BottomSheet (1000): a modal opened from inside a sheet, such as
     a photo preview, must cover it whichever portal mounted first.
     TODO-v10: define a z-index scale in the theme, and use it here.
     */
  z-index: 1001;
`

const StModalContainer = styled.div<{
  fullScreen?: boolean
  noPadding?: boolean
  backdropColor?: string
  maxHeight?: string
}>`
  box-shadow: rgba(0, 0, 0, 0.08) 0px 4px 12px;

  ${({ theme, fullScreen, noPadding, backdropColor, maxHeight }) => {
    const modalTheme = theme.Components.Modal

    return `
      width: ${fullScreen ? '100vw' : '100%'};
      max-width: ${fullScreen ? '100vw' : '600px'};
      height: ${fullScreen ? '100vh' : 'auto'};
      max-height: ${fullScreen ? '100vh' : (maxHeight ?? '80vh')};
      overflow-y: auto;
      border-color: ${modalTheme.Border};
      background-color: ${modalTheme.Background};
      font-size: 12px;

      border-width: 1px;
      border-style: solid;
      border-radius: ${fullScreen ? 0 : `${theme.UI.BorderRadius.Large}px`};

    margin: ${fullScreen ? 0 : `0 ${theme.UI.SpacingPx.Space6}`};
    padding: ${
      noPadding ? 0 : `${theme.UI.SpacingPx.Space7} ${theme.UI.SpacingPx.Space6} ${theme.UI.SpacingPx.Space5}`
    };

    background-color: ${backdropColor};
    `
  }}
`

const AnimatedStModalContainer = motion(StModalContainer)

export { AnimatedStModalContainer, StModalContainer, StModalWrapper }
